import React from 'react';

/**
 * GreyOverlay Component
 * A subtle grey overlay to indicate past time slots
 * Uses absolute positioning to overlay its parent container
 */
const GreyOverlay = ({ show = false, opacity = 0.1, zIndex = 10 }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: `rgba(0, 0, 0, ${opacity})`,
        pointerEvents: 'none',
        zIndex: zIndex,
        transition: 'background-color 0.2s ease',
      }}
    />
  );
};

export default GreyOverlay;











